import moment from 'moment-timezone/builds/moment-timezone-with-data';

// Set default timezone
moment.tz.setDefault('America/Santiago');
